import { RefObject } from 'react';
import { CoverImage, Image, Text } from '@belong/ui';
import clsx from 'clsx';
import { AddressBar } from 'src/components/address-bar/address-bar';
import { HOMEOWNERS_STRINGS } from 'src/features/homeowners/homeowners.strings';
import css from './cover.module.css';

const backgroundElements = [
  { className: css.cloud1, src: '/homeowner-lp/career_landing_cloud_01.svg' },
  { className: css.cloud2, src: '/homeowner-lp/career_landing_cloud_01.svg' },
  {
    className: clsx('hidden lg:block', css.cloud3),
    src: '/homeowner-lp/career_landing_cloud_02.svg',
  },
  { className: css.cloud4, src: '/homeowner-lp/career_landing_cloud_01.svg' },
  {
    className: css.balloon1,
    src: '/homeowner-lp/career_landing_balloon_02.svg',
  },
];

// bgElements are placed relative to a different element depending on the resolution
const bgElements = (
  <div className="relative w-full lg:w-0">
    {backgroundElements.map((el, idx) => (
      <div key={idx} className={clsx('absolute', el.className)}>
        <Image src={el.src} alt="" className="h-auto" />
      </div>
    ))}
  </div>
);

type CoverProps = {
  subtitle: string;
  imageSrc: string;
  ctaRef?: RefObject<HTMLDivElement>;
};

const titlesArray = [
  HOMEOWNERS_STRINGS['cover.titles.firstText'],
  HOMEOWNERS_STRINGS['cover.titles.secondText'],
  HOMEOWNERS_STRINGS['cover.titles.thirdText'],
  HOMEOWNERS_STRINGS['cover.titles.fourthText'],
  HOMEOWNERS_STRINGS['cover.titles.fifthText'],
  HOMEOWNERS_STRINGS['cover.titles.sixthText'],
  HOMEOWNERS_STRINGS['cover.titles.seventhText'],
];

export function Cover({ subtitle, imageSrc, ctaRef }: CoverProps): JSX.Element {
  return (
    <div className="pt-xl md:pt-3xl isolate flex w-full flex-col items-center overflow-hidden">
      <div className="hidden lg:contents">{bgElements}</div>
      <div className="container z-10 flex flex-col items-center">
        <Text
          as="h2"
          variant="h1"
          fontWeight="semibold"
          className={clsx('text-center', css.title)}
        >
          {subtitle}
          <span
            className={clsx(
              'mt-sm lg:mt-sm relative flex flex-col items-center justify-center',
              css.rotatingTextContainer,
            )}
          >
            {titlesArray.map((item, index) => {
              return (
                <Text
                  key={item}
                  as="span"
                  variant="h3"
                  className={clsx('lg:h2', css.rotatingWord)}
                  style={{
                    animationDelay: `${index * 2}s`,
                    animationDuration: `${titlesArray.length * 2}s`,
                  }}
                >
                  {' '}
                  With <span className={css.underlinedText}>{item}</span>
                </Text>
              );
            })}
          </span>
        </Text>

        <div
          className={clsx(
            'mb-md mt-2xl lg:mb-lg flex w-full flex-col items-center',
            css.addressRedirectContainer,
          )}
        >
          <AddressBar ctaRef={ctaRef} />
        </div>
      </div>
      <div className="pt-sm md:pt-3xl isolate flex w-full flex-col items-center overflow-hidden">
        <div className="contents lg:hidden">{bgElements}</div>
        <div
          className={clsx('mt-2xl md:mt-3xl lg:mt-0', css.coverImageContainer)}
        >
          <CoverImage src={imageSrc} maxHeight={580} maxWidth={2000} alt="" />
        </div>
      </div>
    </div>
  );
}
